<template>
<div class="x_box">
    <ol class="breadcrumb x_breadcrumb">
            <li class="breadcrumb-item">
                <router-link to="/po/exchanges">{{ $t('purchase_exchange_list') }}</router-link>
            </li>
            <li class="breadcrumb-item active" aria-current="page">{{ title }}</li>
        </ol>
    <div class="x_header">
        <button type="button"
                class="btn btn-outline-primary btn-sm no-bor"
                @click="$router.go(-1)">
            <i class="fa fa-arrow-circle-o-left"/>
            {{ $t('back') }}
        </button>
        <b-btn variant="outline-primary no-bor"
               size="sm" @click="onSave">
            <i class="fa fa-floppy-o" aria-hidden="true"/>
            {{$t('save')}}
        </b-btn>
    </div>
    <div class="x_body">
        <div class="card x_card">
            <div class="card-body">
                <div class="row">
                    <div class="col-sm-2">
                        <div class="form-group">
                            <label class="control-label blue">{{ $t('vendor') }}</label>
                            <div><VendorSelector @select="vendorSelected" :value="header.VendorName"></VendorSelector></div>
                        </div>
                    </div>
                    <div class="col-sm-2">
                        <div class="form-group">
                            <label class="control-label blue">{{$t('stock')}}</label>
                            <div>
                                <select class="form-control form-control-sm"  v-model="header.BranchId">
                                    <option value=""></option>
                                    <option v-for="ret in branchs" :value="ret.Id" :key="ret.Id">{{ret.Name}}</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-2">
                        <div class="form-group">
                            <label class="control-label blue">{{$t('date')}}</label>
                            <div>
                                <input type="date" class="form-control form-control-sm" v-model="date" />
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-2">
                        <div class="form-group">
                            <label class="control-label blue">{{$t('target')}}</label>
                            <div>
                                <select class="form-control form-control-sm" v-model="header.TargetNo">
                                    <option value="1">{{$t('return_back')}}</option>
                                    <option value="2">{{$t('return_exchange')}}</option>
                                    <option value="3">{{$t('return_for_money')}}</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-2">
                        <div class="form-group">
                            <label class="control-label blue">{{$t('type')}}</label>
                            <div>
                                <select class="form-control form-control-sm" v-model="header.DocSource">
                                    <option value="Order">{{$t('purchase_order')}}</option>
                                    <option value="Bill">{{$t('purchase_invoice')}}</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-2">
                        <div class="form-group">
                            <label class="control-label blue">{{$t('ref_num')}}</label>
                            <div>
                                <input type="text" class="form-control form-control-sm" v-model="header.DocSourceNo" />
                            </div>
                        </div>
                    </div>
                </div>
                <hr>
                <div class="row">
                    <div class="col-sm-12">
                        <table class="grid">
                            <thead>
                                <tr>
                                    <th style="width: 30px;"></th>
                                    <th>{{$t('item_name')}}</th>
                                    <th style="width: 120px;">{{$t('uom')}}</th>
                                    <th style="width: 120px;">{{$t('qty')}}</th>
                                    <th style="width: 120px;">{{$t('cost')}}</th>
                                    <th style="width: 120px;">{{$t('discount')}}</th>
                                    <th style="width: 120px;">{{$t('sub_total')}}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(ret,index) in lines" :key="index">
                                    <td style="width: 30px;">
                                        <button type="button"
                                                class="btn btn-danger btn-remove"
                                                @click="removeLine(index)">
                                            X
                                        </button>
                                    </td>
                                    <td>
                                        <AuthCompleted @select="itemSelect($event, ret)" :value="ret.ItemName" />
                                    </td>
                                    <td>
                                        <UomDropdown :value="ret.UomName" :item_id="ret.ItemId" @select="uomChange($event, ret)"></UomDropdown>
                                    </td>
                                    <td class="text-center">
                                        <input type="number"
                                               class="form-control form-control-sm"
                                               v-model="ret.Quantity"
                                               @keypress="$isKeyNumber"
                                               @change="reCalculate">
                                    </td>
                                    <td class="text-right">
                                        <input type="number"
                                               class="form-control form-control-sm"
                                               v-model="ret.Cost"
                                               @keypress="$isKeyNumber"
                                               @change="reCalculate">
                                    </td>
                                    <td class="text-right">
                                        <input type="number"
                                               class="form-control form-control-sm"
                                               v-model="ret.Discount"
                                               @keypress="$isKeyNumber"
                                               @change="reCalculate">
                                    </td>
                                    <td class="text-right">
                                        <input type="text"
                                               class="form-control form-control-sm text-right"
                                               :value="$money(ret.SubTotal)" />
                                    </td>
                                </tr>
                            </tbody>
                            <tfoot>
                                <tr>
                                    <th rowspan="3" style="width: 30px;"></th>
                                    <th colspan="2" rowspan="3" style="vertical-align:top;">
                                        <button type="button"
                                                class="btn btn-outline-primary btn-sm no-bor"
                                                @click="addLine">
                                            <i class="fa fa-plus"/>
                                            {{ $t('add_line') }}
                                        </button>
                                    </th>
                                    <th colspan="3" class="text-right">{{$t('total_amount')}}:</th>
                                    <th class="text-right">{{$money(header.TotalAmount)}}</th>
                                </tr>
                                <tr>
                                    <th colspan="3" class="text-right">{{$t('discount')}}:</th>
                                    <th class="text-right">{{$money(header.Discount)}}</th>
                                </tr>
                                <tr>
                                    <th colspan="3" class="text-right">សរុបចុងក្រោយ:</th>
                                    <th class="text-right">{{$money(header.PaidAmount)}}</th>
                                </tr>
                            </tfoot>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>
<script>
    import { AuthCompleted } from '../Item';
    import UomDropdown from '../UOM/Dropdown';
    import { VendorSelector } from '../Vendors';
    export default {
        components: {
            AuthCompleted,
            VendorSelector,
            UomDropdown
        },
        data: function(){
            return {
                title: 'បង្កើតថ្មី',
                header: {
                    TargetNo: 1,
                    VendorId: '',
                    VendorName: '',
                    Discount: 0,
                    TotalAmount: 0,
                    PaidAmount: 0,
                    DocSource: 'Order',
                    DocSourceNo: ''
                },
                lines: [{
                    ItemId: '',
                    ItemName: '',
                    Quantity: 1,
                    UomName: '',
                    UomId: '',
                    Price: 0,
                    Cost: 0,
                    Discount: 0,
                    SubTotal: 1
                }],
                date: this.$now().format('YYYY-MM-DD'),
                actionLink: 'po/exchange/save',
                branchs: []
            }
        },
        created: function(){
            let id = this.$route.params.id;
            this.branchList();
            if(id != undefined && id != null && id != ''){
                var loading = this.$loading.show();
                this.title = 'កែប្រែ';
                this.actionLink = 'po/exchange/save';
                this.$api().post('po/exchange/find', { Id: id }).then(res => {
                    var data = res.data.Json;
                    this.header = data.Header;
                    this.lines = data.Lines;
                    this.date = this.$format(this.header.DateCreated, 'YYYY-MM-DD');
                    this.reCalculate();
                }).finally(function() { loading.hide(); });
            }
        },
        methods: {
            branchList(){
                this.$api().post('branch/list', { Limit: 0 }).then(res => {
                    if(this.$isValid(res)){
                        this.branchs = res.data.Data;
                    }
                });
            },
            uomChange(e, line){
                line.UomId = e.UomId;
                line.UomName = e.UomName;
            },
            onSave(){
                let loading = this.$loading.show();
                this.header.Date = this.date;
                this.header.DueDate = this.due_date;
                let req = {
                    Header: this.header,
                    Lines: this.lines
                };
                this.$api().post(this.actionLink, req).then(res => {
                    if(this.$isValid(res)){this.$router.push('/po/exchanges');}
                }).finally(function() { loading.hide(); });
            },
            select(item, line){
                line.ItemId = item.Id;
                line.ItemName = item.Name;
                line.UomId = item.UomId;
                line.UomName = item.UomName
                line.Price = item.Cost;
                this.reCalculate();
            },
            vendorSelected(item){
                this.header.VendorId = item.Id;
                this.header.Contact = item.Address;
            },
            reCalculate(){
                let grand = 0;
                let discount = 0;
                this.lines.map(item => {
                    let total = (Number(item.Quantity) * Number(item.Cost));
                    item.SubTotal =  total - Number(item.Discount);
                    discount += Number(item.Discount);
                    grand += item.SubTotal;
                });
                this.header.TotalAmount = grand;
                this.header.Discount = discount;
                this.header.PaidAmount = grand - discount;
            },
            addLine(){
                this.lines.push({
                    Checked: false,
                    ItemName: '',
                    Quantity: 1,
                    UomName: '',
                    UomId: '',
                    Price: 0,
                    Discount: 0,
                    SubTotal: 0
                });
            },
            removeLine(){
                this.lines = this.lines.filter(item => {
                    return item.Checked == false
                });
                this.isCheck = false;
            },
            itemSelect(evt, item){
                item.ItemName = evt.Name;
                item.ItemId = evt.Id;
            }
        }
    }
</script>
<style scoped>
    label{
        margin-bottom: 0;
    }
    .none-left{
        border-left: none;
    }
</style>
